import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么数百万影迷选择6080影院？五大核心优势告诉你答案
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-lg border border-background-300/40 bg-background-50/70 p-5 md:p-6 text-center transition-all duration-300 hover:border-primary-500/20 hover:bg-background-50"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-500/10 flex items-center justify-center transition-colors duration-200 group-hover:bg-primary-500/20">
                <i className={`${item.icon} text-primary-400 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}